import { registerGlobalErrorHadler } from './logs';

export const APP_START_TIME = new Date();

registerGlobalErrorHadler();
